import React from "react";
import { Fade, Bounce } from "react-reveal";
import profileImage from "../../Assets/Image/Moniruzzaman-Sujon.jpg";
import SocialMediaConnection from "./SocialMediaConnection";
import Education from "./Education";
import Experience from "./Experience";
import Languages from "./Languages";
import Description from "./Description";
import Skills from "./Skills";

const AboutMe = () => {
  return (
    <div className=" md:bg-gradient-to-r from-gray-900 to-transparent py-20">
      <div className=" px-5 mx-auto container ">
        {/* profile  */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-x-8">
          {/* image */}
          <div className="w-full">
            <Bounce left>
              <img className="w-full" src={profileImage} alt="" />
            </Bounce>
            {/* social Links  */}
            <div className="mt-5 mb-10">
              {/* Contacts  */}


              <SocialMediaConnection></SocialMediaConnection>
            </div>
          </div>

          {/* About me  description*/}
          <Description />

          {/* Skillls  */}

          <Skills />


        </div>
        {/* others  */}

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="lg:mt-10">
            <Fade left>
              <Experience />
            </Fade>
          </div>
          <div className="lg:mt-10">
            <Fade top>
              <Education />
            </Fade>
          </div>
          <div className="lg:mt-10">
            <Fade right>
              <Languages />
            </Fade>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AboutMe;
